import { useTheme } from "@emotion/react";
import {
  Add,
  Cancel,
  Delete,
  ManageAccounts,
  PersonSearch,
  Save,
} from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import DeleteModal from "../components/deleteModal.tsx";
import getReq from "../interface/getRequestinterface";
import postReq from "../interface/postRequestinterface";
import { getRequest, postRequest } from "../request";
import Loading from "./loading";

const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 64px)",
  },
  tableContainer: {
    width: "50rem",
  },
  tableHeader: {
    backgroundColor: "#0C3148",
    color: "#fff",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.3rem",
  },
  modalReturnBtn: {
    width: "50%",
    backgroundColor: "#D22027",
    "&:hover": {
      backgroundColor: "#99191e",
    },
  },
  modalAddBtn: {
    width: "50%",
  },
  EditUserBtn: {
    backgroundColor: "#308703",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1e5800",
    },
  },
};
interface user {
  id: string;
  email: string;
  role: string;
  userName: string;
}

interface addUser {
  userName: string;
  role: string;
}
function AdminRequestList() {
  const [userList, setUserList] = useState<Array<user>>([]);
  const [deletedUser, setDeletedUser] = useState<string>("");
  const [openAddUserModal, setOpenAddUserModal] = useState<boolean>(false);
  const [deleteSuccessfull, setDeleteSuccessfull] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [editedUser, setEditedUser] = useState<user>({
    id: "",
    email: "",
    role: "",
    userName: "",
  });
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const theme = useTheme();
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [addUser, setAddUser] = useState<addUser>({
    userName: "",
    role: "",
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    fetchRequestList();
  }, []);
  const fetchRequestList = async () => {
    const data: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/Account/GetUsers`
    )) as getReq;
    if (data && Object.keys(data).length) {
      setUserList(
        data.data.map((x) => ({
          id: x.id,
          userName: x.userName,
          email: x.email,
          role: x.role,
        }))
      );
      setTimeout(() => {
        setisLoading(true);
      }, 1500);
    } else {
      toast.error(data.error);
    }
  };

  const handleDeleteUser = (userId) => {
    setOpenDeleteModal(true);
    setDeletedUser(userId);
  };

  const handleCloseAddUserModal = () => {
    setOpenAddUserModal(false);
    setAddUser({ role: "", userName: "" });
  };

  const handleChangeInput = (event) => {
    setAddUser({
      ...addUser,
      [event.target.name]: event.target.value,
    });
  };

  const handleAddNewUser = async () => {
    let postData = {};
    if (addUser.role === "کارشناس") {
      postData = { ...addUser, roles: ["Expert"] };
    } else {
      postData = { ...addUser, roles: ["Admin"] };
    }
    const data: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/Account/register`,
      postData
    )) as postReq;
    if (data) {
      window.location.reload();
      toast.success("کاربر با موفقیت اضافه شد");
    } else {
      toast.error("نام کاربری نادرست است");
    }
  };

  const handleChangeUserRole = (id, value) => {
    if (value === "کارشناس") {
      setEditedUser((prevState) => {
        return { ...prevState, role: "Expert" };
      });
    } else if (value === "مدیر") {
      setEditedUser((prevState) => {
        return { ...prevState, role: "Admin" };
      });
    } else {
      setEditedUser((prevState) => {
        return { ...prevState, role: "SaleExpert" };
      });
    }
  };

  const handleEditRole = async () => {
    const postData = {
      userName: editedUser.userName,
      roles: [editedUser.role],
    };
    const data: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/Account/ChangeRole/${editedUser.id}`,
      postData
    )) as postReq;
    if (!data.error) {
      toast.success("درخواست با موفقیت انجام شد!");
      window.location.reload();
    } else {
      toast.error(data.error);
    }
  };
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const [isSearch, setIsSearch] = useState(false);
  // const [textSerach, setTextSearch ] = useState(false)
  const handleInput = (text) => {
    setIsSearch(text.target.value ? text.target.value : true);
  };

  const inputStyles = {
    // Customize the input text color, background, and other styles here
    color: "#ffffff", // White text color
    backgroundColor: "transparent", // Transparent background
  };
  const labelStyles = {
    textAlign: "left",
    color: "#ffffff", // White text color for the label
  };

  return (
    <div>
      <div className="background">
        {isLoading ? (
          <>
            <Button
              sx={
                isDesktop
                  ? {
                      position: "absolute",
                      right: "12rem",
                      top: "5.5rem",
                    }
                  : {
                      position: "absolute",
                      right: "1rem",
                      top: "5rem",
                    }
              }
              variant="contained"
              color="primary"
              onClick={() => setOpenAddUserModal(true)}
            >
              کاربر جدید
              <Add />
            </Button>

            <div
              className="container"
              style={isDesktop ? undefined : { marginTop: "3rem" }}
            >
              <div
                style={{ boxShadow: "1px 1px 2px #efefef", maxHeight: "512px" }}
              >
                <TableContainer
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "fit-content",
                    maxHeight: "512px",
                  }}
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="ratesTh"
                          align="center"
                          sx={styles.tableHeader}
                        >
                          {isSearch ? (
                            <Box
                              sx={{ display: "flex", alignItems: "flex-end" }}
                            >
                              <Cancel
                                onClick={() => {
                                  setIsSearch(false);
                                }}
                                sx={{ color: "red", mr: 1, my: 0.5 }}
                              />
                              <TextField
                                InputProps={{
                                  style: inputStyles,
                                }}
                                InputLabelProps={{
                                  style: labelStyles, // Apply white text color to the label
                                  dir: "ltr",
                                }}
                                onChange={handleInput}
                                size="small"
                                id="outlined-basic"
                                label="جستجوی کاربر"
                                variant="standard"
                              />
                            </Box>
                          ) : (
                            <div
                              className="row d-flex justify-content-center align-content-center"
                              style={{ display: "flex" }}
                              onClick={() => {
                                setIsSearch(true);
                              }}
                            >
                              <div>نام کاربری</div>
                              <PersonSearch />
                            </div>
                          )}
                        </TableCell>
                        <TableCell
                          className="ratesTh"
                          align="center"
                          sx={styles.tableHeader}
                        >
                          ایمیل
                        </TableCell>
                        <TableCell
                          className="ratesTh"
                          align="center"
                          sx={styles.tableHeader}
                        >
                          نقش کاربر
                        </TableCell>
                        <TableCell
                          className="ratesTh"
                          align="center"
                          sx={styles.tableHeader}
                        >
                          حذف کاربر
                        </TableCell>
                        <TableCell
                          className="ratesTh"
                          align="center"
                          sx={styles.tableHeader}
                        >
                          تغییر نقش کاربر
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(isSearch && isSearch !== true
                        ? userList.filter((x) => x.userName.includes(isSearch))
                        : userList.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                      ).map((row, index) => {
                        return (
                          <TableRow
                            key={index}
                            className="ratesTr"
                            sx={{
                              "&:last-child , &:last-child": { border: 0 },
                            }}
                          >
                            <TableCell align="center" className="ratesTd">
                              {row.userName}
                            </TableCell>
                            <TableCell align="center" className="ratesTd">
                              {row.email}
                            </TableCell>
                            <TableCell align="center" className="ratesTd">
                              {editedUser.id === row.id ? (
                                <FormControl sx={{ m: 1, minWidth: 120 }}>
                                  <InputLabel>نقش کاربر</InputLabel>
                                  <Select
                                    variant="outlined"
                                    name="role"
                                    size="small"
                                    value={
                                      editedUser.role
                                        ? editedUser.role === "Admin"
                                          ? "مدیر"
                                          : editedUser.role === "Expert"
                                          ? "کارشناس"
                                          : "کارشناس فروش"
                                        : row.role === "Admin"
                                        ? "مدیر"
                                        : row.role === "Expert"
                                        ? "کارشناس"
                                        : "کارشناس فروش"
                                    }
                                    label="نقش کاربر"
                                    onChange={(e) =>
                                      handleChangeUserRole(
                                        row.id,
                                        e.target.value
                                      )
                                    }
                                    renderValue={(value) => value}
                                  >
                                    <MenuItem value={"کارشناس"}>
                                      کارشناس
                                    </MenuItem>
                                    <MenuItem value={"مدیر"}>مدیر</MenuItem>
                                    <MenuItem value={"کارشناس فروش"}>
                                      کارشناس فروش
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              ) : row.role === "Admin" ? (
                                "مدیر"
                              ) : row.role === "Expert" ? (
                                "کارشناس"
                              ) : (
                                "کارشناس فروش"
                              )}
                            </TableCell>
                            <TableCell align="center" className="ratesTd">
                              <IconButton
                                aria-label=""
                                sx={{ color: "#d22027" }}
                                onClick={() => handleDeleteUser(row.id)}
                              >
                                <Delete />
                              </IconButton>
                            </TableCell>
                            <TableCell align="center" className="ratesTd">
                              {editedUser.id === row.id ? (
                                <ButtonGroup
                                  variant="contained"
                                  sx={{ direction: "ltr" }}
                                >
                                  <Button
                                    sx={{
                                      backgroundColor: "#1e1e1e",
                                      color: "#fff",
                                    }}
                                    onClick={() =>
                                      setEditedUser({
                                        id: "",
                                        email: "",
                                        role: "",
                                        userName: "",
                                      })
                                    }
                                  >
                                    <Cancel /> بازگشت
                                  </Button>
                                  <Button
                                    sx={styles.EditUserBtn}
                                    onClick={handleEditRole}
                                  >
                                    <Save /> ذخیره
                                  </Button>
                                </ButtonGroup>
                              ) : (
                                <IconButton
                                  aria-label=""
                                  sx={{ color: "#1e1e1e" }}
                                  onClick={() => {
                                    setEditedUser(
                                      userList.find(
                                        (x) => x.id === row.id
                                      ) as user
                                    );
                                  }}
                                >
                                  <ManageAccounts />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                {userList.length > 5 ? (
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 20]}
                    component="div"
                    labelRowsPerPage={"تعداد سطر های هر صفحه"}
                    count={userList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                ) : null}
              </div>
              {/* </Paper> */}
            </div>
          </>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
        <DeleteModal
          deleteURL={`${process.env.REACT_APP_BASE_URL}/Account/DeleteUser/${deletedUser}`}
          destination="NotLoad"
          openDeleteModal={openDeleteModal}
          parameterName="کاربر مورد نظر"
          setOpenDeleteModal={setOpenDeleteModal}
          setIsSuccessful={setDeleteSuccessfull}
        />
        <Modal
          open={openAddUserModal}
          onClose={handleCloseAddUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles.modalStyle}>
            <Typography
              variant="h6"
              sx={{ width: "100%", textAlign: "center", marginBottom: "1rem" }}
              color="initial"
            >
              تعریف کاربر جدید
            </Typography>
            <TextField
              name="userName"
              label="نام کاربری"
              variant="outlined"
              value={addUser.userName}
              onChange={handleChangeInput}
              size="small"
            />
            <FormControl sx={{ m: 1, minWidth: 120, margin: "0.5rem 0rem" }}>
              <InputLabel>نقش کاربر</InputLabel>
              <Select
                variant="outlined"
                name="role"
                size="small"
                value={addUser.role}
                label="نقش کاربر"
                onChange={handleChangeInput}
                renderValue={(value) => value}
              >
                <MenuItem value={"کارشناس"}>کارشناس</MenuItem>
                <MenuItem value={"مدیر"}>مدیر</MenuItem>
              </Select>
            </FormControl>
            <ButtonGroup
              variant="contained"
              sx={{ direction: "ltr" }}
              aria-label=""
            >
              <Button
                variant="contained"
                sx={styles.modalReturnBtn}
                onClick={handleCloseAddUserModal}
              >
                <Cancel /> بازگشت
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={styles.modalAddBtn}
                onClick={handleAddNewUser}
              >
                <Add /> ثبت کاربر
              </Button>
            </ButtonGroup>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default AdminRequestList;
